import React, {useMemo} from 'react';
import {Stack, styled} from '@mui/material';
import {getEnv} from '../util.js';

const EnvBadgeContainer = styled(Stack, {shouldForwardProp: p=>!p.startsWith('$')})`
    background-color: ${p=>p.$env=='DEV' ? '#3a5777' : '#c75c25'};
    color: #FFF;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 4px;
    border-radius: 0 4px 0 0;
    font-size: 12px;
    font-weight: bold;
    font-family: system-ui;
    z-index: 999999;
`;

const EnvBadge = ()=>{
    let envName = useMemo(()=>getEnv());
    if (!envName||envName=='PRD')
        return null;
    return <EnvBadgeContainer $env={envName}>
      {envName}
    </EnvBadgeContainer>;
};

export default EnvBadge;
